import React, { useState } from 'react'
import styles from './PasswordInput.module.css';
import EyeIcon from '../../../icons/AnimatedEyeIcon/AnimatedEyeIcon';

interface PasswordInputProps {
  label?: string;
  value?: string | null;
  placeHolder?: string;
  onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
  error?: string | null;
  name?: string;
  id?: string;
}

const PasswordInput = ({ label, onChange, error, placeHolder, value, name, id }: PasswordInputProps) => {

  const [isOpen, setIsOpen] = useState(false)

  return (
    <div className={`${styles.inputWrapper} appointmentCard`}>
      {label && <label>{label}</label>}
      <div>
        <div className={styles.passwordWrapper}>
          <input
            id={id || ""}
            name={name || 'password'}
            className={styles.input}
            type={isOpen ? 'text' : 'password'}
            value={value || ""}
            placeholder={placeHolder || 'Enter Password'}
            onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
              onChange && onChange(event);
            }}
          />
          <div className={styles.iconWrapper}>
            <EyeIcon isOpen={isOpen} setIsOpen={setIsOpen} size={28} />
          </div>
        </div>
        {error && <div className={styles.errorText}>{error}</div>}
      </div>
    </div>
  )
}

export default PasswordInput;
